import { Loading } from 'react-admin';
import Loadable from 'react-loadable';


const RoomRuleList = Loadable({ loader: () => import('./roomRuleList'), loading: Loading });
const RoomRuleCreate = Loadable({ loader: () => import('./roomRuleCreate'), loading: Loading });
const RoomRuleEdit = Loadable({ loader: () => import('./roomRuleEdit'), loading: Loading });
const RoomRuleShow = Loadable({ loader: () => import('./roomRuleShow'), loading: Loading });

// eslint-disable-next-line
export default {
  list: RoomRuleList,
  create: RoomRuleCreate,
  show: RoomRuleShow,
  edit: RoomRuleEdit,

};